<div
  class="dashboard-config-panel"
  role="dialog"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  [attr.aria-label]="'liveDashboard.panel.title' | translate"
>
  <div class="dashboard-config-panel__header">
    <div>
      <div class="dashboard-config-panel__title">{{ 'liveDashboard.panel.title' | translate }}</div>
      <div class="dashboard-config-panel__subtitle">
        {{ 'liveDashboard.panel.subtitle' | translate: { name: username() } }}
      </div>
    </div>
    <button
      type="button"
      class="dashboard-config-panel__close"
      [attr.aria-label]="'liveDashboard.panel.close' | translate"
      (click)="onClose()"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <div class="dashboard-config-panel__body">
    <div class="dashboard-config-panel__sections-header">
      {{ 'liveDashboard.panel.sectionsHeader' | translate }}
    </div>

    @for (key of keys; track key) {
      <div class="dashboard-config-panel__row">
        <button
          type="button"
          role="switch"
          class="dashboard-config-panel__switch"
          [class.dashboard-config-panel__switch--on]="isOn(key)"
          [attr.aria-checked]="isOn(key)"
          [attr.data-key]="key"
          [attr.data-testid]="'dash-section-toggle-' + key"
          [attr.aria-label]="'liveDashboard.panel.toggleAria' | translate: { section: labels[key] | translate }"
          (click)="onToggle(key)"
        >
          <span class="dashboard-config-panel__knob"></span>
        </button>
        <span class="dashboard-config-panel__label">{{ labels[key] | translate }}</span>
      </div>
    }
  </div>

  <div class="dashboard-config-panel__footer">
    <button type="button" class="dashboard-config-panel__reset" [disabled]="config().isDefault" (click)="onReset()">
      <mat-icon aria-hidden="true">restart_alt</mat-icon>
      <span>{{ 'liveDashboard.panel.reset' | translate }}</span>
    </button>
    <button type="button" class="dashboard-config-panel__done" (click)="onClose()">
      {{ 'liveDashboard.panel.done' | translate }}
    </button>
  </div>
</div>
